import { AppBar, Tab, Tabs } from '@material-ui/core'
import React from 'react'


function a11yProps(index) {
    return {
      id: `simple-tab-${index}`,
      'aria-controls': `simple-tabpanel-${index}`,
    };
  }
  

const CustomTab = ({value, handleChange})=> {
    return (
        <AppBar position="static" style={{background:"#ffffff"}}>
          <Tabs value={value} onChange={handleChange} aria-label="simple tabs example" 
            color="black" indicatorColor="primary" textColor="primary" centered>
            <Tab label="Pending Request" {...a11yProps(0)} />
            <Tab label="Pending Approval" {...a11yProps(1)} />
            <Tab label="Approved" {...a11yProps(2)} />
            <Tab label="Cancelled" {...a11yProps(3)} />
            <Tab label="Ongoing" {...a11yProps(4)} />
            <Tab label="Completed" {...a11yProps(5)} />
          </Tabs>
        </AppBar>
    )
}
export default CustomTab